import { ColDef } from "ag-grid-community";
import { agGridAutoGroupColId } from "@/components/pages/common/ag-grid/utils/constants/agCommon";

export const getHeaderNameByColId = (
  columnDefs: ColDef[],
  autoGroupColumnDefHeaderName?: string,
) => {
  const names: Record<string, string> = {
    [agGridAutoGroupColId]:
      autoGroupColumnDefHeaderName ?? agGridAutoGroupColId,
  };

  columnDefs.forEach((column) => {
    if (column.colId || column.field) {
      names[column.colId ?? column.field ?? ""] = column.headerName ?? "";
    }
  });

  return names;
};
